export default __webpack_public_path__ + "static/media/IMG_5541.0d781906.jpg";